import React from 'react';
import moment from 'moment';
import { Col, Row, Typography } from 'antd';

const Footer = () => {
  return (
    <Row
      type='flex'
      justify='end'
      style={{
        textAlign: 'right',
      }}
    >
      <Col xs={24}>
        <Typography.Text>
          © 2016 - {moment().format('YYYY')}{' '}
          <a target='_blank' href='https://bytetech.io/'>
            ByteTech
          </a>
        </Typography.Text>
      </Col>
      <Col xs={24}>
        <Typography.Text>Customer Data Platform - Let's Data Talk</Typography.Text>
      </Col>
    </Row>
  );
};

export default Footer;
